import { useNavigate } from "react-router-dom";
import { CheckCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useFetch } from "@/hooks/useFetch";
import { fmtDateTime } from "@/lib/format";
import { StatusBadge } from "@/components/StatusBadge";
import { Card, Empty, PageHeader } from "@/components/Field";

const CAT = { inventory: "Inventario", expiry: "Scadenze", shopping: "Lista della spesa", tasks: "Compiti", events: "Eventi", bookings: "Prenotazioni", admin: "Comunicazioni" };

export default function NotificationsPage() {
  const nav = useNavigate();
  const { data, reload } = useFetch("/notifications?limit=200");
  const open = async (n) => {
    if (!n.read) await api.post(`/notifications/${n.id}/read`);
    if (n.link) nav(n.link);
    else reload();
  };
  return (
    <>
      <PageHeader title="Notifiche" subtitle={data ? `${data.unread} non lette` : ""}>
        {data?.unread > 0 && <Button data-testid="notifications-page-read-all" variant="outline" className="h-11" onClick={async () => { await api.post("/notifications/read-all"); reload(); }}><CheckCheck className="h-4 w-4 mr-1" /> Segna tutte lette</Button>}
      </PageHeader>
      <p className="text-sm text-slate-500">Le notifiche via e-mail e push sul telefono non sono ancora attive: per ora gli avvisi sono conservati qui.</p>
      {data && data.items.length === 0 ? <Empty testId="notifications-empty" text="Nessuna notifica." /> : (
        <Card><ul className="divide-y">
          {data?.items.map((n) => (
            <li key={n.id}>
              <button data-testid={`notification-row-${n.id}`} onClick={() => open(n)} className={`w-full flex items-start gap-3 px-5 py-3 text-left hover:bg-slate-50 ${n.read ? "" : "bg-primary/5"}`}>
                <span className={`mt-2 h-2 w-2 rounded-full shrink-0 ${n.read ? "bg-transparent" : "bg-primary"}`} />
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2"><span className="font-semibold text-slate-900">{n.title}</span><StatusBadge label={CAT[n.category] || n.category} /></div>
                  <div className="text-sm text-slate-600">{n.body}</div>
                  <div className="text-xs text-slate-400">{fmtDateTime(n.created_at)}</div>
                </div>
              </button>
            </li>
          ))}
        </ul></Card>
      )}
    </>
  );
}
